<template>
           <v-radio-group v-model="question.checks[0]" class="mt-0 ml-0 pt-0 mx-auto" @change="update" row>
                                  <v-radio
                                   @change="update"
                                       v-for="(check,ii) in question.options"
                                        :key="ii"
                                        :value="check"
                                      :label="check"
                                      :color="check"
                                      hide-details
                                       :ref="`input${ii}`"
                                       class="mt-0 ml-0 pt-1"
                                  ></v-radio>
                                </v-radio-group>
    
</template>
<script>

export default {
  props: {
      question: {
        type: Object,
        default: () => {}
      }
    },
   data: () => ({
      
  }),
  computed: {
    
  },
  methods: {
    update() {
        this.$emit('update', this.question)
    }
  }
}

</script>
<style>
.mx-auto .v-input__control {
    margin-left: auto;
    margin-right: auto;
}
</style>